const REP_ALIASES = new Set([
  "you",
  "rep",
  "sales rep",
  "sales representative",
  "agent",
  "seller",
  "account manager",
]);

const CLIENT_ALIASES = new Set([
  "client",
  "customer",
  "prospect",
  "buyer",
]);

function normalizedSpeaker(value) {
  return String(value || "").trim().toLowerCase();
}

export function transcriptSpeakerPresentation(speaker) {
  const normalized = normalizedSpeaker(speaker);

  if (REP_ALIASES.has(normalized) || /^(?:speaker\s*)?a$/.test(normalized)) {
    return { label: "You", toneClass: "is-rep", role: "rep" };
  }

  if (CLIENT_ALIASES.has(normalized) || /^(?:speaker\s*)?b$/.test(normalized)) {
    return { label: "Client", toneClass: "is-client", role: "client" };
  }

  return {
    label: String(speaker || "Speaker").trim() || "Speaker",
    toneClass: "",
    role: "unknown",
  };
}

export function formatPlainTranscriptSpeakers(transcript) {
  if (typeof transcript !== "string") return transcript;

  return transcript
    .replace(/^(?:rep|sales rep|sales representative|agent|speaker\s*a)\s*:/gim, "You:")
    .replace(/^(?:client|customer|prospect|speaker\s*b)\s*:/gim, "Client:");
}
